/* global femcare */

/**
 * Represents the newsletter popup functionality.
 */
femcare.newsletter.popupNewsletter = {
    $floatingButtonWrapper: $('.floating-button-wrapper'),

    /**
     * Initializes the newsletter popup functionality if the user isn't already signed up.
     */
    init() {
        if (this.$floatingButtonWrapper.length) {
            if (this.shouldShowFloatingButton('hide_floating_button') && this.shouldShowFloatingButton('newsletter_signup')) {
                this.$floatingButtonWrapper.addClass('floating-button-wrapper--shown');
                $('.floating-button__close').on('click', () => this.hideFloatingButton());

                if (window.innerWidth < 1024) {
                    this.enableMobileDrag();
                }
            }
        }
    },

    /**
     * Checks if the floating button should be shown based on the presence of cookies.
     * @param {string} cookieName - The cookie name to check.
     * @returns {boolean} True if the floating button should be shown, false otherwise.
     */
    shouldShowFloatingButton(cookieName) {
        const cookieValue = this.getCookie(cookieName);

        return cookieValue === 'false' || cookieValue === '';
    },

    /**
     * Retrieves the value of a cookie by its name.
     * @param {string} name - The name of the cookie.
     * @returns {string} The value of the cookie.
     */
    getCookie: function (name) {
        let cookieValue = '';
        let cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.startsWith(name + '=')) {
                cookieValue = cookie.substring(name.length + 1);
                break;
            }
        }

        return cookieValue;
    },

    /**
     * Hides the floating button wrapper and sets a session cookie.
     */
    hideFloatingButton() {
        this.$floatingButtonWrapper.removeClass('floating-button-wrapper--shown');
        document.cookie = 'hide_floating_button=true';
    },

    /**
     * Enables dragging of the floating button on mobile devices.
     * Hides the button when dragged beyond the threshold.
     */
    enableMobileDrag() {
        let isDragging = false;
        let startX = 0;
        const threshold = 50;
        const $floatingButton = $('.floating-button');

        $floatingButton.on('touchstart', e => {
            startX = e.originalEvent.touches[0].clientX;
        });

        $floatingButton.on('touchmove', e => {
            const currentX = e.originalEvent.touches[0].clientX;
            const distance = currentX - startX;

            if (Math.abs(distance) > threshold && !isDragging) {
                isDragging = true;
                $floatingButton.addClass('floating-button--dragging');
            }
        });

        $(window).on('touchend', () => {
            if (isDragging) {
                $floatingButton.removeClass('floating-button--dragging');
                this.hideFloatingButton();
            }
            isDragging = false;
        });
    },
};
